<template>
  <b-container>
    <h1>{{ $t("bi.powerbiview.create") }}</h1>
    <success-fade-alert ref="alert" :msg="alert.success" />
    <fade-alert-danger ref="fadeAlertDanger" :msg="alert.error" />

    <b-row class="mb-3 ml-0">
      <router-link :to="'../bi/' + companyId.toString()">
        <b-button size="sm">{{ $t("geral.backtolist") }}</b-button>
      </router-link>
    </b-row>

    <b-form @submit.prevent="save">
      <b-row>
        <b-col sm="12" md="6" lg="6">
          <crud-data
            :model="model"
            :modelstate="modelstate"
            class="mb-4"
          ></crud-data>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-button type="submit" :disabled="submitted">
            {{ $t("geral.save") }}
          </b-button>
        </b-col>
      </b-row>
    </b-form>
    <!-- {{ model }} -->
  </b-container>
</template>

<script>
export default {
  name: "CreateProfile",
  components: {
    FadeAlertDanger: () => import("@/components/FadeAlertDanger.vue"),
    SuccessFadeAlert: () => import("@/components/SuccessFadeAlert.vue"),
    CrudData: () =>
      import("@/components_rms/BI/PowerBIView/PowerBIViewCrudData.vue"),
  },
  props: {
    companyId: String,
  },
  data() {
    return {
      alert: {
        error: "",
        success: "Registro criado com sucesso",
      },
      submitted: false,
      modelstate: {},
      model: {},
    };
  },
  created() {
    this.newModel();
  },
  methods: {
    newModel() {
      this.model = {
        id: 0,
        companyId: parseInt(this.companyId),
        sidebarTitle: "",
        embendedCode: "",
      };
    },
    save() {
      this.submitted = true;
      this.$apiScheduler
        .post("/powerbiview/create", this.model)
        .then((response) => {
          if (response.data.success) {
            this.newModel();
            this.$refs.alert.show();
          } else {
            this.alert.error = response.data.title;
            this.$refs.fadeAlertDanger.show();
          }
          this.modelstate = {};
          window.scrollTo(0, 0);
          this.submitted = false;
        })
        .catch((error) => {
          this.submitted = false;
          this.modelstate = {};
          if (error.response) {
            if (error.response.status == 400) {
              this.modelstate = error.response.data.errors;
              this.alert.error = "Verifique os dados informados";
            } else {
              if (error.response.data) {
                this.alert.error = error.response.data.errors;
              } else {
                this.alert.error = `${error.response.status} - ${error.response.statusText} `;
              }
            }
          } else {
            this.alert.error = error.message;
          }
          this.$refs.fadeAlertDanger.show();
          window.scrollTo(0, 0);
        });
    },
  },
};
</script>
